<div #clickable class="position-absolute" [ngStyle]="{
  'top.px': box.top,
  'width.px': box.width,
  'height.px': box.height,
  'left.px': box.left,
  'overflow': 'hidden'
}">
  <img *ngIf="backgroundImage"
       [src]="backgroundImage"
       style="position: absolute; top: 0; left: 0; z-index: -1;">
  
  <ng-content></ng-content>  
</div>